import { render, staticRenderFns } from "./PostsWeekCalendar.vue?vue&type=template&id=b5ecc7fc&scoped=true&"
import script from "./PostsWeekCalendar.vue?vue&type=script&lang=js&"
export * from "./PostsWeekCalendar.vue?vue&type=script&lang=js&"
import style0 from "./PostsWeekCalendar.vue?vue&type=style&index=0&id=b5ecc7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ecc7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ecc7fc')) {
      api.createRecord('b5ecc7fc', component.options)
    } else {
      api.reload('b5ecc7fc', component.options)
    }
    module.hot.accept("./PostsWeekCalendar.vue?vue&type=template&id=b5ecc7fc&scoped=true&", function () {
      api.rerender('b5ecc7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/social-media-posting/PostsWeekCalendar.vue"
export default component.exports